import { create } from "zustand";

interface UseSideMenuStateState {
  showMenu: boolean;
  switchShowMenu: () => void;
}

const useSideMenuState = create<UseSideMenuStateState>((set) => ({
  showMenu: true,
  switchShowMenu: () =>
    set((state) => ({ showMenu: !state.showMenu })),
}));

export default useSideMenuState;
